<div class="ai-generic-container">
  <div mat-dialog-title class="text-center mb-3 border-bottom">
    {{ 'ai.generic.' + data?.type?.toLowerCase() | translate }}
  </div>

  <div class="d-flex flex-column ai-generic-body m-1 p-0">
    <div class="mb-2 pb-2">
      <app-mk-editor [data]="data?.response" [readonly]="true" [name]="('ai.generic.title' | translate) + (data?.created | date:'short')"></app-mk-editor>
<!--      <p>{{ data?.response }}</p>-->
    </div>
  </div>

  <div mat-dialog-actions class="d-flex flex-row justify-content-center border-top">
    <!-- TODO: Criar botão para atualizar os dados da IA, por padrão deve trazer a ultima pedida -->
    <!--    <button type="button" (click)="refresh()" class="btn btn-outline-primary btn-sm">{{ 'core.btn.refresh' | translate }} </button>-->
    <!-- TODO: Adicionar exportação para DOC (Word) e envio por e-mail   -->
    <!--    <button type="button" (click)="close()" class="btn btn-outline-secondary btn-sm">{{ 'core.btn.docx' | translate }}</button>-->
    <!--    <button type="button" (click)="close()" class="btn btn-outline-secondary btn-sm">{{ 'core.btn.mail' | translate }}</button>-->
    <button type="button" (click)="close()" class="btn btn-outline-secondary btn-sm">{{ 'core.btn.close' | translate }}</button>
  </div>
</div>
